import { useEffect as c } from "react";
import { SegmentHandler as i } from "./index2.js";
function r(t) {
  const e = t.target?.closest("a");
  if (e)
    try {
      i.instance.track("Clicked Link", {
        text: e.innerText,
        href: e.href,
        isExternal: e.target === "_blank"
      });
    } catch (n) {
      console.error("[Segment] Error tracking link click:", n.message);
    }
}
function k() {
  c(() => (document.addEventListener("click", r), () => document.removeEventListener("click", r)), []);
}
export {
  k as useTrackLinks
};
//# sourceMappingURL=index4.js.map
